import { FC } from 'react';

import { HelpText, HelpChapterProps, HelpComponentWrapper, useConfigSlice, useTranslation } from '@pp/core';
import { Bets } from '../../../config/bets';
import { BetSpot } from '../../gameGrid/betSpot';

export const HelpChapterIntroduction: FC<HelpChapterProps> = ({ content, isStorybook }) => {
  const { translations } = useTranslation();
  if (!content) return null;
  const tableNameKey = useConfigSlice.tableConfig()?.tableName ?? '';
  const tableName = translations[tableNameKey] || tableNameKey;

  return (
    <div>
      <p>
        <HelpText dynamicValues={{ TABLE_NAME: `${tableName}` }}>{String(content.gameDescription)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.gameFeatures)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.gameObjective)}</HelpText>
      </p>
      <div
        style={{
          padding: '2px',
          boxSizing: 'border-box',
          borderRadius: '12px',
          width: '100%',
          height: '100%',
        }}
      >
        <HelpComponentWrapper
          style={{
            width: 'var(--game-help-wrapper-width)',
            margin: '0px auto',
            textAlign: 'center',
            marginTop: 'var(--game-help-betspot-spacing)',
            transform: 'scale(var(--game-help-betspot-scale))',
            maxWidth: isStorybook ? '122px' : 'unset',
          }}
        >
          <div
            style={{
              padding: '2px',
              boxSizing: 'border-box',
              borderRadius: '12px',
              width: '100%',
              height: '100%',
            }}
          >
            <BetSpot
              value={0}
              megaMultiplier={500}
              onBet={(): null => null}
              disabled={false}
              bet={Bets.Forty}
              multiplier={2}
              winning={false}
              isMegaWin={true}
            />
          </div>
        </HelpComponentWrapper>
      </div>
      <p>
        <HelpText>{String(content.megaWin)}</HelpText>
      </p>
    </div>
  );
};
